<section class="container-fluid px-5 py-4 ">
    <header class="row pt-3">
        <div class="col-12 d-flex justify-content-between">
            <div>
                <h4 class="text-white">Editar pago: {{idProject}}</h4>
                <h6 class="text-secondary"></h6>
            </div>
            
            <div class="d-flex justify-content-center align-items-center">
      
                <button
                  class="badge rounded-pill btn btn-outline-light"
                  (click)="goBack()"
                >
                  <i
                    class="fa-solid fa-right-from-bracket m-2 fs-6"
                    aria-hidden="true"
                  ></i>
                  <span class="m-2 fs-6">Volver al listado</span>
                </button>
    
              </div>
            <!-- <div>
                <button class="me-1 btn btn-outline-light" routerLink="./../list" ><i class="fa-solid fa-right-from-bracket" aria-hidden="true"></i> Volver al listado de proyectos</button>
                <button *ngIf="step > 1"  class="mx-2 btn btn-outline-light "(click)="step=step-1"><i class="fa fa-arrow-left" aria-hidden="true"></i> Volver a la etapa anterior</button>
                <button *ngIf="step < 4"  class="ms-1 btn btn-outline-light" (click)="step=step+1" > <i class="fa fa-arrow-right" aria-hidden="true"></i> Siguiente etapa</button>
            </div>            -->
        </div>
    </header>

</section>
<div class="px-5 py-4">
<section class="container-fluid shadow pt-3 pb-2 text-white backgroundTable mt-3 " style="min-height:750px !important;">
    <div class="container-fluid d-flex justify-content-between align-items-center">
        <div>
            <h5 class="ms-3">Editar pago.</h5>
        </div>
    </div>
        <div class="componente-importantes text-start px-5 mt-3" style="min-height:700px;">
            <form action="" method="post" (submit)="formSubmit()" [formGroup]="createPayForm" class="row mx-5">

                <div class="form-group col-md-6 my-2">
                    <label for="formControlInput" class="form-label">Título:</label>
                    <input type="text" class="form-control custom-outline-input date" id="title"
                        formControlName="title">
                </div>
               

                <div class="form-group col-md-6 my-2">
                    <label for="formControlInput" class="form-label">Fecha Pago:</label>
                    <input   readonly type="date" class="form-control custom-outline-input date" id="date_payment"
                        formControlName="date_payment">
                </div>
               

                <div class="form-group col-md-6 my-2">
                    <label for="formControlInput" class="form-label">Moneda:</label>
                    <input  readonly type="text" class="form-control custom-outline-input date" id="money"
                        formControlName="money">
                </div>
                <div class="form-group col-md-6 my-2">
                    <label for="formControlInput" class="form-label">Monto:</label>
                    <input type="text" class="form-control custom-outline-input date" id="pay_amount"
                        formControlName="pay_amount"  (blur)="transformAmount($event)" (keyup)="onKey()" >
                        <label *ngIf="this.active == true" for="formControlInput" class="form-label text-init">Cuando termine escribir el monto, presione click fuera de monto</label>
                </div>



                <!-- <label for="formControlInput" class="form-label mt-3">{{this.datos.name}}</label> -->


                <!-- <form [formGroup]="paymentsform" class="mt-2">
                    <div class="mt-2" formArrayName="items"
                        *ngFor="let item of paymentsform.get('items')['controls']; let i = index;">
                        <div class="row" [formGroupName]="i">
                            <div *ngIf="listPayInto.length != 0">
                                <div class="mt-2" formArrayName="items" *ngFor="let item of listPayInto">
                                    <div class="row" [formGroupName]="item.id">

                                        <div class="col-3 ">
                                            <div class="form-group mt-1">
                                                <label for="formControlInput" class="form-label">Her:
                                                    {{item.hes}}</label>
                                                <input type="text" placeholder="HES" [value]="item.hes"
                                                    class="form-control custom-outline-input" formControlName="hes">
                                            </div>
                                        </div>
                                        <div class="col-4">
                                            <div class="form-group mt-1">
                                                <label for="formControlInput" class="form-label">Factura:
                                                    {{item.facture}}</label>
                                                <input type="text" placeholder="FACTURA" [value]="item.facture"
                                                    class="form-control custom-outline-input" formControlName="facture">
                                            </div>
                                        </div>

                                        <div class="col-4">
                                            <div class="form-group mt-1">
                                                <label for="formControlInput" class="form-label">Fecha factura:
                                                    {{fechaCambio(item.facture_date)}}</label>
                                                <input type="date" [value]="fechaCambio(item.facture_date)"
                                                    class="form-control custom-outline-input date" id="facture_date"
                                                    formControlName="facture_date">
                                            </div>
                                        </div>

                                    </div>


                                </div>

                            </div>
                        </div>
                    </div>
                </form> -->

                <form [formGroup]="paymentsform" class="mt-2">

                    <div class="mt-2" formArrayName="items" *ngFor="let item of paymentsform.get('items')['controls']; let i = index;">
                        <div class="row" [formGroupName]="i">
                        <div class="col-3 ">
                            <div class="form-group mt-1">
                            <label for="formControlInput" class="form-label">Her:</label>
                            <input type="text" placeholder="HES" class="form-control custom-outline-input" formControlName="hes">
                            </div>
                        </div>
                        <div class="col-4">
                            <div class="form-group mt-1">
                                <label for="formControlInput" class="form-label">Factura:</label>
                            <input type="text" placeholder="FACTURA" class="form-control custom-outline-input" formControlName="facture">
                            </div>
                        </div>
                      
                        <div class="col-4">
                        <div class="form-group mt-1">
                            <label for="formControlInput" class="form-label">Fecha factura:</label>
                            <input type="date" placeholder="FECHA FACTURA" class="form-control custom-outline-input date" id="facture_date"
                                formControlName="facture_date">
                        </div>
                        </div>

                        </div>
    
    
                    </div>
    
    
                    </form>
                <br>
                <div class="form-group d-flex justify-content-sm-end mt-4">
                    <div>
                        <button class="btn btn-outline-light me-3" style="font-size: 15px;"> <i _ngcontent-xfk-c127=""
                                class="fa-solid fa-floppy-disk m-1"></i> Guardar Usuario</button>
                    </div>




                </div>


            </form>


        </div>


    

</section>
</div>

<router-outlet></router-outlet>